import { create } from 'zustand';

export const useUpgradeTierModalStore = create((set) => ({
  isOpen: false,
  resourceType: '',
  currentLimit: null,
  upgradeUrl: null,
  onClose: null,
  openUpgradeTierModal: ({ resourceType, currentLimit, upgradeUrl, onClose }) => {
    set({
      isOpen: true,
      resourceType: resourceType || 'resources',
      currentLimit,
      upgradeUrl,
      onClose,
    });
  },
  closeUpgradeTierModal: () => {
    const { onClose } = useUpgradeTierModalStore.getState();
    if (onClose) {
      onClose();
    }
    set({
      isOpen: false,
      resourceType: '',
      currentLimit: null,
      upgradeUrl: null,
      onClose: null,
    });
  },
}));
